import Vue from 'vue'
const DEFAULT_TITLE = 'Greenapsis Solar'

export default (to, from, next) => {
    const title = to.meta.title || DEFAULT_TITLE

    Vue.nextTick(() => {
        document.title = title;
    })

    next()
}